import React, { PureComponent, PropTypes } from 'react';
import { connect } from 'react-redux';

import * as actions from '../../store/signUp/actions';

import SignUpWelcome from './sign_up_welcome';
import SignUpUserType from './sign_up_user_type';
import SignUpEmployee from './sign_up_employee';
import SignUpAccount from './sign_up_account';
import SignUpConfirmation from './sign_up_confirmation';
import SignUpCarousel from './sign_up_carousel';

/**
 * @type {PureComponent} SignUp the disconnected pure component
 */
export class SignUp extends PureComponent {
  render() {
    const { children, ...props } = this.props;

    /**
     * children need to have a key to be animated
     */
    props.key = props.location.pathname;

    return (
      <div>
        {React.cloneElement(children, props)}
      </div>
    );
  }
}


/**
 * SignUp view props
 */
SignUp.propTypes = {
  children: PropTypes.element,
};


/**
 * @param {Object} state the current application state
 * @returns {Object} return the current application state as an object
 */
const props = state => ({
  signUp: {
    validForm: state.getIn(['signUp', 'validForm']),
    working: state.getIn(['signUp', 'working']),
    toast: state.getIn(['signUp', 'toast']),
    complete: state.getIn(['signUp', 'complete']),
    name: state.getIn(['signUp', 'name']).toJS(),
    email: state.getIn(['signUp', 'email']).toJS(),
    phone: state.getIn(['signUp', 'phone']).toJS(),
    phonecode: state.getIn(['signUp', 'phonecode']).toJS(),
    password: state.getIn(['signUp', 'password']).toJS(),
    businessName: state.getIn(['signUp', 'businessName']).toJS(),
    staffCount: state.getIn(['signUp', 'staffCount']).toJS(),
  },
});


/**
 * @type {PureComponent} SignUp connected to the redux store
 */
export default connect(props, actions)(SignUp);


/**
 * the child route views
 */
export {
  SignUpWelcome,
  SignUpUserType,
  SignUpEmployee,
  SignUpAccount,
  SignUpConfirmation,
  SignUpCarousel,
};



// WEBPACK FOOTER //
// ./src/components/sign_up/index.jsx